module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/5/5-c301055c121500376e51d3635db550a1.jpg";